import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import SingleSourceComponent from './SingleSource/SingleSource';
import GeneralFiltersComponent from './generalFilters/generalFilters';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as Utils from '../../../common/utilSvc';
import * as DbUtils from '../../../common/DbSvc';
import * as Const from '../../../common/const';
import * as CoreHelper from '../../../common/coreHelper';
import './Meeting.css';
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/functions';
import { isNullOrUndefined } from "util";
import CreateSourceComponent from './createSource/createSource';
import GeneralDataComponent from './generalData/generalData';


class MeetingComponent extends React.Component {
    
    constructor(props){

        //Props include meeting, userId
        super(props);

        this.state = {
            isCopied: false,
            createSource: false,
            sources: [],
            originalSources: [],
            saveStatus: {},
            isCollapsed: {},
            meetingActivity: {},
            generalData: {
                'companyWiki': null
            },
            generalFilters: {
                'Key Facts': true,
                'Summary': true,
                'Financial Details': true,
                'News': true
            }
        }

        this.createSource = this.createSource.bind(this);
        this.deleteSource = this.deleteSource.bind(this);
        this.editSource = this.editSource.bind(this);
        this.filterGoogleNewsResults = this.filterGoogleNewsResults.bind(this);
        this.getAllData = this.getAllData.bind(this);
        this.getCompanyMission = this.getCompanyMission.bind(this);
        this.getCompanyWikiData = this.getCompanyWikiData.bind(this);
        this.getCompanyGoogleSearchData = this.getCompanyGoogleSearchData.bind(this);
        this.getCompanyGoogleNewsData = this.getCompanyGoogleNewsData.bind(this);
        this.getFundingData = this.getFundingData.bind(this);
        this.getSourceText = this.getSourceText.bind(this);
        this.getGeneralDataFromDb = this.getGeneralDataFromDb.bind(this);
        this.getMissingWikiKeys = this.getMissingWikiKeys.bind(this);
        this.getPublicStockRelatedData = this.getPublicStockRelatedData.bind(this);
        this.getSourcesFromDb = this.getSourcesFromDb.bind(this);
        this.getOtherUsersActivityFromDb = this.getOtherUsersActivityFromDb.bind(this);
        this.googleApiCall = this.googleApiCall.bind(this);
        this.googleApiCallListResults = this.googleApiCallListResults.bind(this);
        this.googleNewsApiCall = this.googleNewsApiCall.bind(this);
        this.googleNlpEntityExtraction = this.googleNlpEntityExtraction.bind(this);
        this.renderSource = this.renderSource.bind(this);
        this.resetSource = this.resetSource.bind(this);
        this.saveSource = this.saveSource.bind(this);
        this.saveAllSources = this.saveAllSources.bind(this);
        this.scrapeSingleWikiLink = this.scrapeSingleWikiLink.bind(this);
        this.selectSourceText = this.selectSourceText.bind(this);
        this.setAllExpand = this.setAllExpand.bind(this);
        this.stockTickerFromWikiApiCall = this.stockTickerFromWikiApiCall.bind(this);
        this.toggleCreateSource = this.toggleCreateSource.bind(this);
        this.toggleExpandButton = this.toggleExpandButton.bind(this);
        this.toggleGeneralFilter = this.toggleGeneralFilter.bind(this);
        this.isUnsavedSource = this.isUnsavedSource.bind(this); 
        this.yahooIncomeStatementApiCall = this.yahooIncomeStatementApiCall.bind(this); 
        
        this.meetingSourcesListener = null;
        this.meetingRealtimeActivityListener = null;
    }

    async getAllData(){

        this.getCompanyMission();
        this.getCompanyGoogleSearchData();
        this.getCompanyGoogleNewsData();

    }

    async getCompanyMission(){
        // console.log(this.props.meeting['company']);
        if(!isNullOrUndefined(this.props.meeting) && 
        'company' in this.props.meeting && !isNullOrUndefined(this.props.meeting['company'])
            && this.props.meeting['company'].trim().length>0){
            //TODO Check if link is valid here
        
            const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleSearchPull';
            // console.log(endpoint);
            let searchQuery = "what is " + this.props.meeting['company'] +" mission?";
            if(CoreHelper.getCompanyWords(this.props.meeting['company']).length>2){
                searchQuery = "what is " + this.props.meeting['company'] +" company mission?";
            }
            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'query': searchQuery}),
                    headers: new Headers({'content-type': 'application/json'})
                }
                )
            .catch((err)=>{console.log(err)});  
            if(!isNullOrUndefined(res)){
                let resJson = await res.json();

                if('answer_box' in resJson){
                    let companyMission = {};
                    let answer = resJson['answer_box'];
                    // console.log(answer);

                    if('title' in answer){
                        companyMission['title'] = answer['title'];
                    }
                    if('snippet' in answer){
                        companyMission['snippet'] = answer['snippet'];
                    }
                    if('link' in answer){
                        companyMission['link'] = answer['link'];
                    }

                    let generalData = this.state.generalData;
                    generalData['companyMission'] = companyMission;
                    this.setState({
                        generalData: generalData
                    });
                }                         
            }  
            
        }
    }

    async filterGoogleNewsResults(results, company){
        // console.log(results);
        if(isNullOrUndefined(results) || isNullOrUndefined(company))    
            return [];

        /* 
        NLP research
        // Get Google NLP answer here
        let str = company + " is a company. ";
        for(let i=0; i<results.length; i++){
            if('title' in results[i]){
                results[i]['startOffset'] = str.length;
                str += results[i].title +'\n';
                results[i]['endOffset'] = str.length - 1;
            }
        }

        
        //cMap gets those locations where substring is present in string
        let cMap = CoreHelper.getIndicesOfCompanyNamesInString(str, company);
        let smallStr = str.toLowerCase();
        let newStr = "";
        for(let i=0; i<str.length; i++){
            if(i in cMap){
                for(let j=i; j<=cMap[i] && j<str.length; j++)
                    newStr += str[j];
                i = cMap[i];                
            }
            else{
                newStr += smallStr[i];
            }
        }
        str = newStr;

       let nlpResults = await this.googleNlpEntityExtraction(str);
       console.log(str);
       console.log(nlpResults);
       let relevantNlpResultMentions = [];
       for(let i=0; i<nlpResults.length; i++){
           let nlpResult = nlpResults[i];

           if('name' in nlpResult && nlpResult.name.toLowerCase().includes(company.toLowerCase())){
               if('mentions' in nlpResult){
                for(let j=0; j<nlpResult.mentions.length; j++){
                    if('beginOffset' in nlpResult.mentions[j] && nlpResult.mentions[j].type=="PROPER")
                        relevantNlpResultMentions.push(nlpResult.mentions[j].beginOffset);
                }
               }
           }
       }
       relevantNlpResultMentions.sort((a,b) => {return a-b});
       console.log(results, relevantNlpResultMentions);
        */
       
        let companyWords = CoreHelper.getCompanyWords(company); 
        let companySubstrings = CoreHelper.createLinearSubstringsForCompany(companyWords);
        // console.log(companyWords, companySubstrings)
        let finalAns = [];
        for(let i=0; i<results.length; i++){
            // console.log(results[i].title.toLowerCase(), company.toLowerCase());
            // Old way
            for(let j=0; j<companySubstrings.length; j++){
                let currCompanyStr = companySubstrings[j];
                if('title' in results[i] && j>= companySubstrings.length-2 &&
                results[i].title.toLowerCase().includes(currCompanyStr.toLowerCase())){                
                    finalAns.push(results[i]);
                }
            }            

            /* 
            // NLP Research
            for(let j=0; j<relevantNlpResultMentions.length; j++){
                if(relevantNlpResultMentions[j]>=results[i].startOffset
                    && relevantNlpResultMentions[j]<=results[i].endOffset){
                        finalAns.push(results[i]);
                    }
            }
            */
        }

        //Bucketing
        let buckets = {
            'other':[], 'revenue':[], 'growth':[], 'market':[], 'funding': []
        }
        for(let i=0; i<finalAns.length; i++){
            let othersFlag = true;
            if(finalAns[i].title.toLowerCase().includes('revenue') || finalAns[i].title.toLowerCase().includes('sales')
            || finalAns[i].title.toLowerCase().includes('earning')){
                buckets['revenue'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('growth')){
                buckets['growth'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('fund') || finalAns[i].title.toLowerCase().includes('raise')){
                buckets['funding'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('product') || finalAns[i].title.toLowerCase().includes('expan') || 
            finalAns[i].title.toLowerCase().includes('market') ){
                buckets['market'].push(finalAns[i]);
                othersFlag = false;
            }
            if(othersFlag){
                buckets.other.push(finalAns[i]);
            }
        }
        // console.log(buckets);

        //Retrieve top news based on buckets
        let keys = ['growth', 'funding', 'market', 'revenue', 'other'];
        let added = {};
        let topNewsOutput = [];
        let maxLimit = Const.maxNewsArticles;
        for(let i=0; i<keys.length; i++){
            let bucketKeyArr = buckets[keys[i]];
            let cnt = 0, limit = 1;
            if(i==keys.length-1){
                limit = maxLimit - topNewsOutput.length;
            }
            for(let j=0;j<bucketKeyArr.length && cnt<limit; j++){
                let newsItem = bucketKeyArr[j];
                if(!(newsItem.link in added)){
                    added[newsItem.link] = '';
                    cnt++;
                    topNewsOutput.push(newsItem);        
                }
            }
        }
        // console.log(topNewsOutput);
        
        return topNewsOutput;
    }

    async getCompanyGoogleNewsData(){
        let generalCompanyNewsQuery = Const.generalCompanyNewsQuery;

        if(!isNullOrUndefined(this.props.meeting) && 
        'company' in this.props.meeting && !isNullOrUndefined(this.props.meeting['company'])
            && this.props.meeting['company'].trim().length>0){
            
            let company = this.props.meeting['company'].trim();
            let output = [];
            
            for(let i=0; i<generalCompanyNewsQuery.length; i++){       
                let query = "";         
                let currNewsQuery = generalCompanyNewsQuery[i].data;
                for(let j=0; j<currNewsQuery.length; j++){
                    if(currNewsQuery[j] == "#")
                        query += company;
                    else 
                        query += currNewsQuery[j];
                }
                // console.log(query);

                if(generalCompanyNewsQuery[i].type == "news"){
                    let result = this.googleNewsApiCall(query);
                    output.push(result);
                }
                else if(generalCompanyNewsQuery[i].type == "search"){
                    let result = this.googleApiCallListResults(query);
                    output.push(result);
                }
            }     
            let finalOutput = await Promise.all(output);
            // console.log(finalOutput);

            let commonOutput = [];
            let existingLinks = {};
            for(let i=0; i<finalOutput.length; i++){
                for(let j=0; !isNullOrUndefined(finalOutput[i]) &&
                 j<finalOutput[i].length; j++){
                     let link = finalOutput[i][j].link;
                     if(!(link in existingLinks) && 'date' in finalOutput[i][j]){
                        let parsedDate = Date.parse(finalOutput[i][j].date);
                        let isSearchResult = false;
                        if(generalCompanyNewsQuery[i].type == 'search')
                            isSearchResult = true;

                        //If date is valid for search Result OR if it is news result
                        if(!isSearchResult || (!isNaN(parsedDate))){
                            commonOutput.push(finalOutput[i][j]);
                            existingLinks[link] = '';                                
                        }
                     }
                 }
            }
            // console.log(commonOutput);

            let finalArr = await this.filterGoogleNewsResults(commonOutput, company);
            // console.log(finalArr);

            let generalData = this.state.generalData;
            generalData['companyNews'] = finalArr;
            this.setState({generalData: generalData});
        }
    }

    async getCompanyGoogleSearchData(){
        if(!isNullOrUndefined(this.props.meeting) && 
        'company' in this.props.meeting && !isNullOrUndefined(this.props.meeting['company'])
            && this.props.meeting['company'].trim().length>0){
            
            let company = this.props.meeting['company'].trim();

            const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleSearchPull';
            // console.log(endpoint);
            let searchQuery = this.props.meeting['company'] +" company";
            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'query': searchQuery}),
                    headers: new Headers({'content-type': 'application/json'})
                }
            ).catch((err)=>{console.log(err)}); 

            if(!isNullOrUndefined(res)){
                let resJson = await res.json();

                this.getCompanyWikiData(resJson, company)
            }
        }
    }

    async scrapeSingleWikiLink(url, companyStr){
        // console.log(url);
        let output = {};
        let companyStrings = [];
        if(!isNullOrUndefined(companyStr))
            companyStrings = companyStr;

        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeWikiForGeneralData';
        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'url': url, 'companyStrings':companyStrings}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            if(!isNullOrUndefined(resJson)){
                // console.log(resJson);
                let neededKeys = Const.generalWikiData;
                let extraKeys = Const.extraWikiData;
                let cnt = 0;
                for(let key in resJson){
                    for(let i=0; i<neededKeys.length;i++){
                        if(key.toLowerCase().includes(neededKeys[i])){
                            output[neededKeys[i]] = resJson[key];
                            cnt++;
                        }
                    }
                    for(let i=0; i<extraKeys.length;i++){
                        if(key.includes(extraKeys[i])){
                            output[extraKeys[i]] = resJson[key];
                        }
                    }
                }
                output['neededKeys_cnt'] = cnt;
            }
        }
        return output;
    }

    async getCompanyWikiData(resJson, company){
        //Wikipedia
        let wikiLinks = Utils.getWikipediaLinks(resJson);
        // console.log(wikiLinks, resJson);

        for(let i=0;!isNullOrUndefined(wikiLinks) && i<wikiLinks.length; i++){
            //TODO Make this parallel
            let url = wikiLinks[i].link;
            let companyStr = [];
            if(!isNullOrUndefined(company) && company.trim().length>0){
                companyStr = CoreHelper.createLinearSubstringsForCompany(
                    CoreHelper.getCompanyWords(company)
                );
            }

            let output = await this.scrapeSingleWikiLink(url, companyStr);
            wikiLinks[i]['data'] = output;
            wikiLinks[i]['dataCnt'] = output.neededKeys_cnt;
        }
        wikiLinks.sort(function(a,b){
            return b.dataCnt - a.dataCnt
        });
        // console.log(wikiLinks);

        let generalData = this.state.generalData;
        let missingKeysQuery = Const.missingKeysQuery;
        let neededKeys = Const.generalWikiData;
        let missingKeys = [];
        let finalWikiLink = null;
        if(wikiLinks.length>0){
            finalWikiLink = wikiLinks[0];
            // console.log(finalWikiLink);
            
            //Do all the wiki stuff here            
            for(let i=0; i<neededKeys.length; i++){
                let key = neededKeys[i];
                if(key in finalWikiLink.data){
                    generalData[key] = 
                    { 'data': finalWikiLink.data[key], 'link': finalWikiLink.link}

                    if(key == 'industry' || key == 'key people'){
                        generalData[key].data = Utils.breakStringAfterScraping(generalData[key].data, ", ");
                    }
                }
                else if(key in missingKeysQuery){
                    missingKeys.push(key);
                }
            }


            //Wiki image
            if('imageLogo' in finalWikiLink.data){
                generalData['imageLogo'] = {
                    url: finalWikiLink.data.imageLogo
                }
            }
            if('summaryText' in finalWikiLink.data){
                generalData['summaryText'] = 
                {
                    'data': finalWikiLink.data['summaryText'],
                    'link': finalWikiLink.link
                }
            }
            // console.log(generalData);            
        }
        else{
            //All keys missing!

            for(let i=0; i<neededKeys.length; i++){
                let key = neededKeys[i];
                if(key in missingKeysQuery){
                    missingKeys.push(key);
                }
            }
        }

        //Public company
        if('type' in generalData && generalData['type'].data =='Public'){
            generalData['isPublic'] = true;
            if(!isNullOrUndefined(finalWikiLink))
                this.stockTickerFromWikiApiCall(finalWikiLink.link)
        }

        //If 'type is not in general data, then wiki page hasn't loaded. Most likely private because public companies have wiki page
        if(!('type' in generalData) ||
        (!(generalData['type'].data.trim().toLowerCase().includes('public')) && 
        !(generalData['type'].data.trim().toLowerCase().includes('subsidiary'))
        )
        ){
            generalData['isPrivate'] = true;
            this.getFundingData();
        }

        // console.log(missingKeys);
        if(missingKeys.length>0){
            let output = await this.getMissingWikiKeys(missingKeys);
            // console.log(output);

            if(!isNullOrUndefined(output)){
                for(var key in output){
                    generalData[key] = output[key];
                }
            }

        }
        this.setState({generalData: generalData});
    }

    async getMissingWikiKeys(missingKeys){

        // console.log(missingKeys);
        let finalOutput = {};

        if(!isNullOrUndefined(this.props.meeting) && 'company' in this.props.meeting){
            let dataOutput = [];
            let company = this.props.meeting['company'].trim();
    
            let missingKeysQuery = Const.missingKeysQuery;
            let prOutput = [];
            for(let j=0; j<missingKeys.length; j++){
                if(missingKeys[j] in missingKeysQuery){
                    let queryArr = missingKeysQuery[missingKeys[j]];
                    let query = queryArr[0]+company+queryArr[1];
                    let currOutput = this.googleApiCall(query);
                    prOutput.push(currOutput);
                    dataOutput.push({
                        'key': missingKeys[j],
                        'data': {}
                    })
                }
            }

            let output = await Promise.all(prOutput);
            // console.log(output);
            if(!isNullOrUndefined(output)){
                for(let i=0;i<output.length;i++){
                    dataOutput[i].data = CoreHelper.getGoogleAnswer(output[i]);
                    if(Object.keys(dataOutput[i].data).length>0)
                        finalOutput[dataOutput[i].key] = dataOutput[i].data;
                }
            }

            let snippetKeys = {}, snippetText = "";
            for(let key in finalOutput){
                if(finalOutput[key].isSnippet && 'data' in  finalOutput[key] && finalOutput[key].data.trim().length>0){
                    let text = finalOutput[key].data.trim();
                    snippetKeys[key] = {
                        start: snippetText.length,
                        end: snippetText.length + text.length + 1
                    }
                    snippetText += text + ". ";
                }
            }
            // console.log(finalOutput);
            // console.log(snippetKeys, snippetText);

            if(snippetText.trim().length>0){
                let nlpMissingKeys = await this.googleNlpEntityExtraction(snippetText);
                // console.log(nlpMissingKeys);

                let nlpAnswers = CoreHelper.getNlpGoogleAnswer(snippetKeys, nlpMissingKeys, snippetText);
                // console.log(nlpAnswers);
                for(let key in nlpAnswers){
                    if(key in finalOutput){
                        finalOutput[key].data = nlpAnswers[key];
                        delete finalOutput[key].isSnippet;
                    }
                }
            }
            // console.log(output,finalOutput);
            
        }
        else{
            return {};
        }
        return finalOutput;
    }

    async stockTickerFromWikiApiCall(wikiUrl){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeWikiForStockTicker';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'url': wikiUrl}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    

            if(!isNullOrUndefined(output) && 'ans' in output){
                let tickers = output.ans;
                let generalData = this.state.generalData;
                generalData['stockTickers'] = tickers;
                this.setState({
                    generalData: generalData
                })

                //Get public stock data
                this.getPublicStockRelatedData(tickers);
            }
        }
    }

    async getFundingData(){
        if(!isNullOrUndefined(this.props.meeting) && 
        'company' in this.props.meeting && !isNullOrUndefined(this.props.meeting['company'])){
            let company = this.props.meeting['company'];
            let searchQ = this.props.meeting['company'] + " funding news";

            let googleList = await this.googleApiCall(searchQ);

            let finOutput = CoreHelper.getFundingFromGoogleSearch(googleList, company);
            // console.log(googleList, finOutput);
            // console.log(finOutput);

            if(finOutput.length>0){
                let generalData = this.state.generalData;
                generalData['funding'] = finOutput;
                this.setState({
                    generalData: generalData
                });
            }
        }

    }

    async googleNewsApiCall(searchQuery){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleNewsPull';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'query': searchQuery}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    async googleApiCall(searchQuery){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleSearchPull';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'query': searchQuery}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    async googleApiCallListResults(searchQuery){
        let results = await this.googleApiCall(searchQuery);
        let arr = [];
        if('answer_box' in results){
            let answerBox = results['answer_box']
            if('link' in answerBox && 'title' in answerBox){
                arr.push(answerBox);
            }
        }
        if('organic_results' in results){
            let organicResults = results['organic_results'];
            for(let i=0; !isNullOrUndefined(organicResults) && i<organicResults.length; i++){
                arr.push(organicResults[i]);
            }
        }
        return arr;
    }

    getGeneralDataFromDb(){

    }

    getSourcesFromDb(){
        if(!isNullOrUndefined(this.props.meeting)){
            // this.setState({areMeetingsLoading: true});
            let scope = this;
            let sources = this.state.sources;   
            let orignalSources = this.state.originalSources;
            let saveStatus = this.state.saveStatus;                    
            this.meetingSourcesListener = firebase.firestore().collection("Meetings").doc(this.props.meeting.id).collection('sources').onSnapshot(
                querySnapshot => {
                    querySnapshot.docChanges().forEach(change => {
                        
                        let source = change.doc.data();
                        // console.log(meeting);
                        if (change.type === 'added') {
                            sources.push(source);
                            orignalSources.push(JSON.parse(JSON.stringify(source)));
                            saveStatus[source.link] = JSON.parse(JSON.stringify(source));
                            scope.setState({
                                orignalSources: orignalSources
                            });
                        }
                        if (change.type === 'modified') {
                            for(let i=0; i<sources.length; i++){
                                if(!isNullOrUndefined(sources[i].link) && !isNullOrUndefined(source.link) && 
                                sources[i].link == source.link){
                                    sources[i] = source;
                                    saveStatus[source.link] = JSON.parse(JSON.stringify(source));
                                }
                            }
                        }
                        if (change.type === 'removed') {
                            let newSources = [];
                            for(let i=0; i<sources.length; i++){
                                if(!(!isNullOrUndefined(sources[i].link) && !isNullOrUndefined(source.link) && 
                                sources[i].link == source.link)){
                                    newSources.push(sources[i]);
                                }
                            }
                            sources = newSources;
                            delete saveStatus[source.link];
                        }
                        scope.setState({
                            sources:sources,
                            saveStatus: saveStatus
                        });
                    });
                }
            )
        }     
    }

    createSource(source){
        if('link' in source && source.link.trim().length>0){

            for(let i=0; !isNullOrUndefined(this.state.sources) && i<this.state.sources.length; 
            i++)
            {
                if(source.link == this.state.sources[i].link)
                    return;
            }
        
            DbUtils.createMeetingResearchSource(this.props.meeting, source);
        }
    }

    deleteSource(link){
        let source = {
            link: link,
            text : 'Dont care!'
        }
        DbUtils.deleteMeetingResearchSource(this.props.meeting, source);
    }

    editSource(id, type, val){
        let sources = this.state.sources;
        if(id < sources.length)
            sources[id][type] = val;
        this.setState({sources:sources});
    }

    resetSource(id){
        let sources = this.state.sources;
        let originalSources = this.state.originalSources;

        if(id < sources.length){
            let currLink = sources[id].link;
            for(let i=0; i<originalSources.length;i++){
                if(originalSources[i].link == currLink){
                    this.editSource(id, "text", originalSources[i].text);
                }
            }
        }
    }

    saveAllSources(excludedSources){
        let sources = this.state.sources;
        let saveStatus = this.state.saveStatus;

        for(let i=0; i<sources.length; i++){
            if(this.isUnsavedSource(sources[i], saveStatus)){
                if(!(!isNullOrUndefined(excludedSources) && sources[i].link in excludedSources)){
                    this.saveSource(sources[i]);
                }
            }
        }
    }

    saveSource(source){
        DbUtils.saveMeetingResearchSource(this.props.meeting, source)
    }

    selectSourceText(source){
        let meetingActivity = this.state.meetingActivity;
        let userHash = Utils.getShaKey(this.props.userId);
        if(userHash in meetingActivity && meetingActivity[userHash].link==source.link && 
            (Date.now() - meetingActivity[userHash].ts < 30*60*1000)){
                //2 min has not passed, do nothing
            }
        else{
            DbUtils.selectMeetingSource(this.props.meeting, source, this.props.userId);
        }
    }

    isUnsavedSource(source, saveStatus){
        if('link' in source && source.link in saveStatus && 
        !isNullOrUndefined(saveStatus[source.link].text)){
            if(saveStatus[source.link].text == source.text){
                return false;
            }
        }
        return true;
    }

    renderSource(source, index){
        let isCollapsed = false;
        if(source.link in this.state.isCollapsed)
            isCollapsed = true;
        let showSave = this.isUnsavedSource(source, this.state.saveStatus);
        let meetingSourceActivityString = Utils.getMeetingSourceActivityString(this.state.meetingActivity, source);
        return (
            <SingleSourceComponent 
                    id = {index}
                    link = {source.link}
                    text = {source.text}
                    isOpen = {!isCollapsed}
                    meetingSourceActivityString = {meetingSourceActivityString}
                    source = {source}
                    deleteSource = {this.deleteSource}
                    resetSource = {this.resetSource}
                    editSource = {this.editSource}
                    saveSource = {this.saveSource}
                    showSave = {showSave}
                    selectSourceText = {this.selectSourceText}
                    toggleExpandButton = {this.toggleExpandButton}/>
        )
    }

    toggleExpandButton(id){
        let sources = this.state.sources;
        let isCollapsed = this.state.isCollapsed;
        if(id < sources.length){
            let currLink = sources[id].link;
            if(!(currLink in isCollapsed)){
                isCollapsed[currLink]='';
            }
            else{
                delete isCollapsed[currLink];
            }
            this.setState({isCollapsed: isCollapsed});
        }
    }

    setAllExpand(isExpand){
        let isCollapsed = this.state.isCollapsed;
        if(isExpand){
            //expand all
            isCollapsed = {};
        }
        else{
            let sources = this.state.sources;
            for(let i=0; i<sources.length; i++){
                if('link' in sources[i])
                    isCollapsed[sources[i].link]='';
            }
        }
        this.setState({isCollapsed: isCollapsed});
    }

    getOtherUsersActivityFromDb(){
        this.meetingRealtimeActivityListener = firebase.database().ref('Meetings/'+ this.props.meeting.id +'/users/');

        let meetingActivity = this.state.meetingActivity;
        let scope = this;
        this.meetingRealtimeActivityListener.on('child_added', function(data){
            let userVal = data.val();
            let userKey = data.key;
            meetingActivity[userKey] = userVal;
            scope.setState({
                meetingActivity: meetingActivity
            });
        });
        this.meetingRealtimeActivityListener.on('child_changed', function(data){
            let userVal = data.val();
            let userKey = data.key;
            meetingActivity[userKey] = userVal;
            scope.setState({
                meetingActivity: meetingActivity
            });
        });
        this.meetingRealtimeActivityListener.on('child_removed', function(data){
            let userKey = data.key;
            delete meetingActivity[userKey];
            scope.setState({
                meetingActivity: meetingActivity
            });
        });
    }

    getSourceText(sources){
        let text = "";
        for(let i=0; i<sources.length; i++){
            if('text' in sources[i] && sources[i].text.trim().length>0){
                let currText = sources[i].text.trim();
                currText += "\n";
                if('link' in sources[i]){
                    let finText = "";
                    for(let j=0; j<currText.length; j++){
                        if((j>0 && currText[j-1]!='\n') && currText[j]=='\n' && (j==currText.length-1 || currText[j+1]=='\n')){
                            finText += ("\n(Source: " + sources[i].link + ")\n");
                        }
                        else if(!(j>0 && j<currText.length-1 && currText[j]=='\n' 
                        && currText[j-1]=='\n' && currText[j+1]=='\n')){
                            finText += currText[j];
                        }
                    }
                    currText = finText.trim();
                }
                currText +="\n";
                text += currText;
            }
            text +="\n";
        }
        //console.log(text);
        return text;
    }

    toggleCreateSource(){
        this.setState({
            createSource: !this.state.createSource
        });
    }

    toggleGeneralFilter(option){
        let generalFilters = this.state.generalFilters;
        if(!isNullOrUndefined(option) && option in generalFilters){
            generalFilters[option] = !generalFilters[option];
            this.setState({
                generalFilters: generalFilters
            });
        }
    }

    componentDidMount(){
        this.getSourcesFromDb();
        this.getOtherUsersActivityFromDb();
        
        /*
        // Works well
        try{
            var addMessage = firebase.functions().httpsCallable('entityExtraction');
            addMessage({ 'text': "Hey this is me Shashank." })
            .then((result) => {
                // Read result of the Cloud Function.
                // console.log(result);
            });
        }catch (e) {
            console.log(e);
        }
        */

        // this.googleNlpEntityExtraction("VITA HEALTH GROUP LIMITED is located in BURY ST. EDMUNDS, United Kingdom and is part of the Ambulatory Health Care Services Industry. VITA HEALTH GROUP LIMITED has 261 employees at this location and generates $33.66 million in sales (USD).")
        
        
    }

    async googleNlpEntityExtraction(text){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/entityExtraction';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'text':text}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    async getPublicStockRelatedData(stockTickers){
        if(!isNullOrUndefined(stockTickers) && stockTickers.length>0){
            let mainTicker = stockTickers[0];

            let allOutputs = [];

            //1: Financial data
            let incomeStatement = this.yahooIncomeStatementApiCall(mainTicker);
            allOutputs.push(incomeStatement);

            let res = await Promise.all(allOutputs);
            let generalData = this.state.generalData;

            if(res.length>=1 && !isNullOrUndefined(res[0])){
                let incomeStatement = res[0];
                generalData['incomeStatement'] = {
                    data: incomeStatement,
                    link: 'https://finance.yahoo.com/quote/' + mainTicker + '/financials'
                }
            }

            this.setState({
                generalData: generalData
            });
        }
    }

    async yahooIncomeStatementApiCall(stock){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeYahooForIncomeStatement';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'stock': stock}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    componentWillUnmount(){
        if(!isNullOrUndefined(this.meetingSourcesListener)){
            this.meetingSourcesListener();
        }
        if(!isNullOrUndefined(this.meetingRealtimeActivityListener)){
            this.meetingRealtimeActivityListener.off();
        }
    }

    render(){
        let renderSources = null;
        if(!isNullOrUndefined(this.state.sources)){
            renderSources = this.state.sources.map((source, index) =>
                this.renderSource(source, index)
            );
        } 

        let linkToShare ='https://flowpro-9e1c6.web.app/joinMeeting/' + this.props.meeting.id;

        return (
            <div>
                <h3>Meeting Research</h3>
                <p>
                    Company: {this.props.meeting.company}
                    <br/><br/>
                    Attendees: {Utils.getMeetingAttendeesString(this.props.meeting.attendees)} 
                    <br/><br/>
                </p>
                <p>Link to share is <a href={linkToShare}>{linkToShare}</a></p>
                <div style={{display:'flex', flexWrap:'wrap', marginBottom:'10px', marginLeft:'1em'}}>
                    <div>
                        <CopyToClipboard text={this.getSourceText(this.state.sources)}
                        onCopy={() => {this.setState({isCopied:true})}}>                        
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1">
                                    <div>Copy Text</div>
                            </Button>
                        </CopyToClipboard>
                    </div>    
                    {!this.state.createSource?
                        <div>
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1" 
                                onClick={() => {this.toggleCreateSource()}}>
                                    
                                        <div>Create Source</div>
                            </Button>
                        </div>
                        :
                        null
                    }   
                    <div>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick={() => {this.saveAllSources({})}}>
                                <div>Save All</div>
                        </Button>
                    </div>                                                       
                    <div>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick={() => {this.setAllExpand(false)}}>
                                <div>Collapse all</div>
                        </Button>
                    </div>                          
                    <div>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick={() => {this.setAllExpand(true)}}>
                                <div>Expand all</div>
                        </Button>
                    </div>                           
                </div>
                {this.state.createSource?
                    <div>
                        <CreateSourceComponent 
                            meeting = {this.props.meeting}
                            createSource = {this.createSource}
                            toggleCreateSource = {this.toggleCreateSource}
                            />
                    </div>
                    :
                    null
                }
                <div>
                    <GeneralFiltersComponent 
                        generalFilters = {this.state.generalFilters}
                        toggleGeneralFilter = {this.toggleGeneralFilter}
                    />
                </div>
                <div>
                    <GeneralDataComponent
                        generalData = {this.state.generalData}
                        generalFilters = {this.state.generalFilters}
                        debug={true}
                        getAllData = {this.getAllData}
                        getCompanyMission = {this.getCompanyMission}
                        getCompanyGoogleSearchData = {this.getCompanyGoogleSearchData}
                        getCompanyGoogleNewsData = {this.getCompanyGoogleNewsData}
                        getPublicStockRelatedData = {this.getPublicStockRelatedData}
                        getFundingData = {this.getFundingData}
                        />
                </div>
                <div>
                    {renderSources}
                </div>

            </div>
        )
    }
}
export default MeetingComponent;

//TODO Undo, reset